document.addEventListener('DOMContentLoaded', function() {
  const cartTotalPrice = document.querySelector('.cart-button-container .cart-total-price');
    document.querySelectorAll('.add-to-cart-form').forEach(function(form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault();

            const formData = new FormData(form);
            const variantId = formData.get('id');
            let properties = {};
            const lineItemPropertyCount = formData.get('lineItemPropertiesCount');
            for (let i = 0; i < lineItemPropertyCount; i++) {
                properties[`_Property ${i + 1}`] = formData.get(`properties[LineItem${i}]`);
            }
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    id: variantId,
                    properties,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Product added to cart:', data);
                updateCartDrawer();
                updateCartBubble();
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
            })
            .catch(error => {
                console.error('Error adding product to cart:', error);
            });
        });
    });

    function updateCartDrawer() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartItemsContainer = document.querySelector('.cart-drawer-contents .cart-items');
                cartItemsContainer.innerHTML = '';

                cart.items.forEach(item => {

                    let sortedOptions = item.options_with_values.sort((a, b) => {
                        if (a.name.toLowerCase() === 'color') return -1;
                        if (b.name.toLowerCase() === 'color') return 1;
                        return 0;
                    }).filter(option => option.name.toLowerCase() !== 'title' && option.value.toLowerCase() !== 'default title');

                    for (let key in item.properties) {
                        sortedOptions.push({
                            name: key,
                            value: item.properties[key]
                        });
                    }

                    const optionValues = sortedOptions.map(option => {
                        let value = option.value;
                        if (option.name.toLowerCase() === 'size') {
                            value += ' Diameter';
                        }
                        return value;
                    }).join(', ');
                  console.log(optionValues)
                  const cartItemHtml = `
                  <div class='cart-item' data-key='${item.key}'>
                        <div class="image_container">
                            <img src="${item.image}" alt="${item.title}" class="cart-item-image" />
                        </div>
                        <div class="cart-item-details">
                            <div class="cart-item-title-quantity">
                                <a class="cart-item-title" href="${item.url}">${item.title}</a>
                                <div class="quantity-controls">
                                    <button class="quantity-minus" data-key="${item.key}">−</button>
                                    <input type="text" value="${item.quantity}" readonly />
                                    <button class="quantity-plus" data-key="${item.key}">+</button>
                                </div>
                            </div>
                            <div class="variant-options">
                                <p>${optionValues}</p>
                            </div>
                            <p class="cart-item-price">$${(item.price / 100).toFixed(2)}</p>
                            <button class="remove-item" data-key="${item.key}">Remove</button>
                        </div>
                    </div>
                    `;
                    cartItemsContainer.innerHTML += cartItemHtml;
                    updateCartBubble();
                });
                cartTotalPrice.textContent = `$${(cart.total_price / 100).toFixed(2)}`;

                document.querySelectorAll('.quantity-minus').forEach(button => {
                    button.addEventListener('click', function () {
                        updateCartQuantity(button.dataset.key, -1);
                        updateCartBubble();
                    });
                });

                document.querySelectorAll('.quantity-plus').forEach(button => {
                    button.addEventListener('click', function () {
                        updateCartQuantity(button.dataset.key, 1);
                        updateCartBubble();
                    });
                });

                document.querySelectorAll('.remove-item').forEach(button => {
                    button.addEventListener('click', function () {
                        removeCartItem(button.dataset.key);
                        updateCartBubble();
                    });
                });

                // Open the cart drawer
                document.querySelector('.cart-drawer').classList.add('open');
            })
            .catch(error => {
                console.error('Error fetching cart data:', error);
            });
    }

    function removeCartItem(key) {
      fetch('/cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              id: key,
              quantity: 0
          })
      })
          .then(response => response.json())
          .then(data => {
              console.log('Item removed from cart:', data);
              var cartItemElement = document.querySelector(`.cart-item[data-key="${key}"]`);
              if (cartItemElement) {
                  cartItemElement.remove();
                  updateCartBubble();
              }
          })
          .catch(error => {
              console.error('Error removing item from cart:', error);
          });
  }

  function updateCartQuantity(key, change) {
      fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
              const item = data.items.find(item => item.key === key);
              if (item) {
                  const newQuantity = item.quantity + change;
                  if (newQuantity > 0) {
                      fetch('/cart/change.js', {
                          method: 'POST',
                          headers: {
                              'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({
                              id: key,
                              quantity: newQuantity
                          })
                      })
                          .then(response => response.json())
                          .then(data => {
                              updateCartDrawer(data);
                              updateCartBubble()
                          });
                  }
              }
          });
  }

  function updateCartBubble() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            var cartBubble = document.querySelector('.cart-bubble');
            if (data.item_count > 0) {
                if (!cartBubble) {
                    cartBubble = document.createElement('div');
                    cartBubble.classList.add('cart-bubble');
                    document.querySelector('.cart-button').appendChild(cartBubble);
                }
                cartBubble.textContent = data.item_count;
            } else if (cartBubble) {
                cartBubble.remove();
            }
        });
}
});

